import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { defineComponent, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import zxTitleUrl from "@/assets/img/m/homePage/zx-title.png";
import { getArticleList } from "@/api/common";
// import {newsTabData} from "@/config/race-news"
// components
import InformationSwiperBox from "./informationSwiperBox.vue";
import NewsList from "@/components/common/news-list.vue";
// hooks
import { useRaceNews } from "@/hooks/race-news";
export default defineComponent({
  name: "PcInformation",
  setup() {
    const {
      newsState,
      switchNewsFct,
      clickNewsItemFct
    } = useRaceNews();

    // 组件状态
    const state = reactive({
      activeIndex: 1,
      swiperSetInfo: {
        slidesPerView: 1,
        initialSlide: 0,
        spaceBetween: 10,
        key: "wj-three-informationSwiperBox",
        type: "three-container-informationSwiperBox",
        slideList: []
      }
    });
    const router = useRouter();
    onMounted(() => {
      getSwiperList();
    });
    const onActiveChange = active => {
      state.activeIndex = active;
      switchNewsFct({
        value: active
      });
    };
    const getSwiperList = () => {
      const params = {
        code: ["match_center_hot_news_banner"],
        pageRows: 5
      };
      getArticleList(params).then(res => {
        if (res.code === 0) {
          state.swiperSetInfo.slideList = res.data.list || [];
        }
      }).catch(err => console.log(err));
    };
    return () => {
      return _createVNode("div", {
        "class": "information-box"
      }, [_createVNode("div", {
        "class": "title-box"
      }, [_createVNode("img", {
        "class": "title",
        "src": zxTitleUrl
      }, null)]), _createVNode(InformationSwiperBox, {
        "swiperSetInfo": state.swiperSetInfo
      }, null), _createVNode("div", {
        "class": "sub-title"
      }, [_createVNode("div", {
        "class": "btn-box"
      }, [_createVNode("div", {
        "onClick": () => {
          onActiveChange(1);
        },
        "class": ["btn", state.activeIndex === 1 ? "active-btn" : ""]
      }, [_createTextVNode("\u8D5B\u4E8B\u65B0\u95FB")]), _createVNode("div", {
        "class": "divide hidden"
      }, null), _createVNode("div", {
        "class": ["btn", state.activeIndex === 2 ? "active-btn" : "hidden"],
        "onClick": () => {
          onActiveChange(2);
        }
      }, [_createTextVNode("\u8D5B\u51B5\u8D44\u8BAF")])]), _createVNode("div", {
        "class": "more"
      }, [_createVNode("img", {
        "class": "more-btn hidden",
        "src": require(`@/assets/img/m/homePage/zx-more.png`),
        "onClick": () => router.push("/race-news")
      }, null)])]), _createVNode(NewsList, {
        "newsData": newsState.newsData.slice(0, 5),
        "showType": false,
        "isHome": true,
        "onClickNewsItem": clickNewsItemFct
      }, null)]);
    };
  }
});